// import HeaderSearchController from './headerSearch';

export default class HeaderController {
    constructor() {
        this.headerElement = null;
        this.menuButton = null;
        this.threshold = 1;

        this.init();
        this.resize();
    }

    init() {
        this.headerElement = document.querySelector("header");
        this.menuButton = this.headerElement.querySelector(".menuButton");

        // Register events
        window.app.registerResizeEvent(this.resize.bind(this));
        window.app.registerScrollEvent(this.scroll.bind(this));

        // Click events
        this.menuButton.addEventListener("click", this.toggleMenu.bind(this));

        this.initSubmenu();
    }

    toggleMenu() {
        this.headerElement.classList.toggle("mobileMenuActive");
    }

    resize() {
        this.previousScroll = window.pageYOffset;

        this.scroll();
    }

    scroll() {
        if (window.pageYOffset > this.threshold) {
            this.hide();
        } else {
            this.show();
        }
    }

    hide() {
        this.headerElement.classList.add("smallLogo");
    }

    show() {
        this.headerElement.classList.remove("smallLogo");
    }

    initSubmenu() {
        const submenus = Array.from(
            this.headerElement.querySelectorAll(`li > a + ul.submenu`)
        );
        const submenuTriggers = submenus.map(
            (submenu) => submenu.previousElementSibling
        );

        const closeAllSubmenus = () => {
            submenus.forEach((submenu) => {
                const parent = submenu.parentElement;
                parent.classList.remove("active");
                submenu.setAttribute("aria-hidden", "true");
                submenu.previousElementSibling.setAttribute(
                    "aria-expanded",
                    "false"
                );
            });
        };

        submenuTriggers.forEach((trigger) => {
            const parent = trigger.parentElement;
            const submenu = trigger.nextElementSibling;

            // Add ARIA attributes
            trigger.setAttribute("aria-haspopup", "true");
            trigger.setAttribute("aria-expanded", "false");
            submenu.setAttribute("aria-hidden", "true");
            submenu.setAttribute("role", "menu");

            trigger.addEventListener("click", (e) => {
                e.preventDefault();

                const isOpen = parent.classList.contains("active");
                closeAllSubmenus(); // close others

                if (!isOpen) {
                    parent.classList.add("active");
                    submenu.setAttribute("aria-hidden", "false");
                    trigger.setAttribute("aria-expanded", "true");
                }
            });
        });

        // Close on click outside
        document.addEventListener("click", (e) => {
            if (!this.headerElement.contains(e.target)) {
                closeAllSubmenus();
            }
        });

        // Close on ESC key
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
                closeAllSubmenus();
            }
        });
    }
}
